export class UserLoginRequestModel {
  public username: string;

  public password: string;

  public rememberMe = false;
}
